import React from "react";
import PayoutWorkspace from "./PayoutWorkspace";
const Refund = props => <PayoutWorkspace mode="refund" history={props.history} />;
export default Refund;
